module.exports = __webpack_public_path__ + "media/images/covers/discover-your-future/discover-logo-4-bfe53208563448d1d6d5816b054646fc.png";